import React from "react";

const PaymentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none">
      <path
        d="M5.22495 4.3999C4.42267 4.3999 3.65325 4.71861 3.08595 5.2859C2.51866 5.8532 2.19995 6.62262 2.19995 7.4249V8.7999H19.8V7.4249C19.8 6.62262 19.4812 5.8532 18.9139 5.2859C18.3467 4.71861 17.5772 4.3999 16.775 4.3999H5.22495ZM19.8 9.8999H2.19995V14.5749C2.19995 15.3772 2.51866 16.1466 3.08595 16.7139C3.65325 17.2812 4.42267 17.5999 5.22495 17.5999H16.775C17.5772 17.5999 18.3467 17.2812 18.9139 16.7139C19.4812 16.1466 19.8 15.3772 19.8 14.5749V9.8999ZM14.85 14.2999H17.05C17.1958 14.2999 17.3357 14.3578 17.4389 14.461C17.542 14.5641 17.6 14.704 17.6 14.8499C17.6 14.9958 17.542 15.1357 17.4389 15.2388C17.3357 15.342 17.1958 15.3999 17.05 15.3999H14.85C14.7041 15.3999 14.5642 15.342 14.461 15.2388C14.3579 15.1357 14.3 14.9958 14.3 14.8499C14.3 14.704 14.3579 14.5641 14.461 14.461C14.5642 14.3578 14.7041 14.2999 14.85 14.2999Z"
        fill="#0F84FF"
      />
    </svg>
  );
};

export default PaymentIcon;
